import { render, staticRenderFns } from "./SendingSchemesSection.vue?vue&type=template&id=ece7540c&scoped=true"
import script from "./SendingSchemesSection.vue?vue&type=script&lang=js"
export * from "./SendingSchemesSection.vue?vue&type=script&lang=js"
import style0 from "./SendingSchemesSection.vue?vue&type=style&index=0&id=ece7540c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece7540c",
  null
  
)

export default component.exports